// Utility to check and clean expired cart data
export const checkAndCleanExpiredCart = () => {
  try {
    const cartData = localStorage.getItem("cart");
    if (cartData) {
      const parsed = JSON.parse(cartData);
      const now = Date.now();
      const fiveHours = 5 * 60 * 60 * 1000; // 5 hours in milliseconds
      
      // Check if cart is older than 5 hours
      if (parsed.timestamp && (now - parsed.timestamp) > fiveHours) {
        localStorage.removeItem("cart");
        return true; // Cart was cleared
      }
    }
    return false; // Cart was not cleared
  } catch (error) {
    console.error("Error checking cart expiration:", error);
    localStorage.removeItem("cart");
    return true; // Cart was cleared due to error
  }
};

// Set up periodic cleanup check (every hour)
export const setupCartCleanup = () => {
  // Check immediately on app start
  checkAndCleanExpiredCart();
  
  // Set up periodic check every hour
  setInterval(() => {
    checkAndCleanExpiredCart();
  }, 60 * 60 * 1000); // 1 hour in milliseconds
};
